import { inrMajorToDisplay, parseCurrencyType } from '@/lib/currency'
import { tickerAmt } from '@/lib/format'
import type { NetExposureBookKind } from './netExposureDisplayCurrency'

/**
 * Workstation bet-list Matched / Unmatched.
 *
 * Stake from API is INR rupees. For POINTS / POINT@1 players, show display
 * points (₹100 → 1) on every book kind — match, bookmaker, fancy/session,
 * and other. INR players keep the raw ticker figure.
 *
 * `bookKind` is kept so callers can pass the market surface; conversion is
 * by bet currency, not by kind (fancy POINTS was incorrectly left in INR).
 */
export function betListMatchedUnmatchedAmt(
  amount: number | null | undefined,
  currencyType: string | undefined,
  _bookKind: NetExposureBookKind,
): string {
  const ccy = parseCurrencyType(currencyType)
  if (ccy === 'INR') return tickerAmt(amount)
  if (amount == null || typeof amount !== 'number' || !Number.isFinite(amount) || amount === 0) {
    return tickerAmt(amount)
  }
  return tickerAmt(inrMajorToDisplay(amount, ccy))
}
